const CONCERT_TRACK_NODE_TYPE = 24;

export function getNodeDisplayName(
  node,
  allBhajanNodes,
  shouldIncludeNodeId,
  displayKey
) {
  let name =
    displayKey == null || node.data[displayKey] == null
      ? node.data.name
      : node.data[displayKey];

  /**
   * Concert tracks are hard to visualize. This adds more context so the correct track can be selected.
   */
  if (node.nodeTypeId === CONCERT_TRACK_NODE_TYPE) {
    if (name == null) {
      // loop bhajan edges, use name on that, concatenate
      const bhajanIds = node.edges
        .filter(e => e.name === "bhajan")
        .map(e => e.nodeId);
      const bhajanNodes = bhajanIds.map(nodeId =>
        allBhajanNodes.find(n => n.nodeId === nodeId)
      );
      const prefix = bhajanNodes.length > 1 ? "Multi: " : "";
      name = prefix + bhajanNodes.map(n => n.data.name).join(", ");
    }
    name = `${name} - ${node.data.itemNum} - ${node.data.instrNums}`;
  }

  if (shouldIncludeNodeId) {
    name += ` - #${node.nodeId}`;
  }

  return name;
}
